import BaseModule from './BaseModule.js';

class CustomerAccessAttempt extends BaseModule {
  async paginate({
    page,
    per_page,
    term,
    ip_address,
    status,
    reason,
    context,
    customer_id,
    only_blocked,
    only_active_blocks,
  }) {
    return await this.get(`/back-office/customer-access-attempts`, {
      params: {
        page,
        per_page,
        term,
        ip_address,
        status,
        reason,
        context,
        customer_id,
        only_blocked,
        only_active_blocks,
      },
    });
  }

  async groups({ page, per_page, term, customer_id, context, only_blocked, only_active_blocks }) {
    return await this.get(`/back-office/customer-access-attempts/groups`, {
      params: {
        page,
        per_page,
        term,
        customer_id,
        context,
        only_blocked,
        only_active_blocks,
      },
    });
  }

  async cidrSuggestions({ page, per_page, customer_id, version, min_ips, term }) {
    return await this.get(`/back-office/customer-access-attempts/cidr-suggestions`, {
      params: {
        page,
        per_page,
        customer_id,
        version,
        min_ips,
        term,
      },
    });
  }
}

export default CustomerAccessAttempt;
